import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

const useSearchResultsStyles = makeStyles(theme => ({
  resultsListContainer: {
    '& div:not(:first-child)': {
      marginTop: '0.3em'
    }
  }
}));

const useResultItemStyles = makeStyles(theme => ({
  resultItemContainer: {
    border: '1px solid #ddd',
    backgroundColor:'white',
    padding:'6px',
    width:'99%',
    '&:hover': { background: '#EFEFEF' },
    '& div': {
      width:'15%',
      display:'inline-block'
    },
    '& div:last-child': {
      textAlign:'right'
    }
  }
}));

const formatProcessStepForHolds = (processStep, onHoldByName, onHoldDate, onHoldReason, reviewedByName, reviewedOn) => {
  if (onHoldByName && onHoldByName != '') {
    let retValue = `${processStep}: ${onHoldByName} - ${onHoldDate} - ${onHoldReason}`;

    if (reviewedByName && reviewedByName != '') {
      return `${retValue} | Reviewed By: ${reviewedByName} on ${reviewedOn}`;
    }
    else {
      return retValue;
    }
  } else {
    return processStep;
  }
};

const ResultItem = ({
  encounterId,
  patientName,
  mrn,
  dateOfService,
  accountNumber,
  payer,
  facility,
  finalizedBy,
  auditedBy,
  finalizedOn,
  auditedOn,
  auditedFor,
  riskScore,
  processStep,
  encounterProcess,
  onHoldByName,
  onHoldDate,
  onHoldReason,
  reviewedByName,
  reviewedOn,
  handleRedirect,
  redirectUrl
}) => {
  const classes = useResultItemStyles();
  return (
    <div className={classes.resultItemContainer}>
      <div>
        <span>{patientName}</span>
      </div>
      <div>
        <span>{mrn}</span>
      </div>
      <div>
        <span>{new Date(dateOfService).toLocaleDateString()}</span>
      </div>
      <div style={{ width: '40%' }}>
        <span>{encounterProcess} - {formatProcessStepForHolds(processStep, onHoldByName, onHoldDate, onHoldReason, reviewedByName, reviewedOn)}</span>
      </div>
      <div>
        <Link to={redirectUrl} target='_blank'>View</Link>
      </div>
    </div>
  );
};

const SearchResults = ({
  results,
  boundActions,
  history
}) => {
  const classes = useResultItemStyles();
  return (
    <div>
      <div>
        <h5>Found <strong>{results.length}</strong> encounters</h5>
      </div>

      <div className={classes.resultItemContainer}>
        <div>
          <span>Patient Name</span>
        </div>
        <div>
          <span>MRN</span>
        </div>
        <div>
          <span>DOS</span>
        </div>
        <div style={{ width: '40%', textAlign: 'left' }}>
          <span>Status</span>
        </div>
      </div>
        {
          results.map(x => (
            <ResultItem
              key={x.encounterId}
              handleRedirect={() => boundActions.navigateToDetails(
                x.encounterId,
                history.push
              )}
              redirectUrl={boundActions.navigateToReviewDetails(x.encounterId)}
              {...x}
            />
          ))
        }
      </div>
  );
};

SearchResults.propTypes = {};

export default SearchResults;
